import { Component, Inject } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { RequestUpdateContactClient } from '../../data';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ClientService } from '../../components/client.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-update-info-client',
  templateUrl: './update-info-client.component.html',
  styleUrls: ['./update-info-client.component.scss']
})
export class UpdateInfoClientComponent {
  clientId: number;
  request: RequestUpdateContactClient;
  type: string;
  formEmail: FormGroup;
  formTelefono: FormGroup;

  constructor(private fb: FormBuilder, @Inject(MAT_DIALOG_DATA)public data: any, public dialogRef: MatDialogRef<UpdateInfoClientComponent>, private clientService: ClientService) {
    
    this.clientId = data.clientId;
    this.type = data.type
    
    this.formEmail = this.fb.group({
      email: ['', [Validators.required, this.emailValidator]],
    });

    this.formTelefono = this.fb.group({
      telefono: ['', [Validators.required, Validators.minLength(9), Validators.maxLength(9)]],
    });
  }

  ngOnInit() {
    console.log("Id: ", this.clientId);
  }

  public cerrarDialogo() {
    this.dialogRef.close();
  }

  public emailValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (!value) {
      return null;
    }
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValidEmail = emailPattern.test(value);
    if (!isValidEmail) {
      return { emailInvalid: true };
    }
    return null;
  }

  submitFormEmail() {
    this.request = {
      clientId: this.clientId,
      type: this.type,
      data: this.formEmail.get('email')?.value
    }
    this.clientService.updateContactInfoClient(this.request).subscribe({
      next: (response) => {
        Swal.fire({
          title: 'Email Actualizado Exitosamente',
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        }).then((result) => {
          if (result.isConfirmed) {
            this.cerrarDialogo();
          }
        });
      },
      error: (err) => {
        console.log(err);
      }
    });
  }

  submitFormTelefono() {
    this.request = {
      clientId: this.clientId,
      type: this.type,
      data: this.formTelefono.get('telefono')?.value
    }
    this.clientService.updateContactInfoClient(this.request).subscribe({
      next: (response) => {
        Swal.fire({
          title: 'Telefono Actualizado Exitosamente',
          icon: 'success',
          showConfirmButton: true,
          confirmButtonText: 'Cerrar'
        }).then((result) => {
          if (result.isConfirmed) {
            this.cerrarDialogo();
          }
        });
      },
      error: (err) => {
        console.log(err);
      }
    });
  }
  
}
